import { useCallback } from 'react'
import { requests } from '../../../core/ajax'

export const useTokenGenerator = () => {
  const generateOneUseLink = useCallback((userId, profileId, appId, extraInfo) => {
    const body = {
      extra_1: profileId,
      extra_2: appId,
      extra_3: JSON.stringify(extraInfo),
    }
    return requests.post(`/instalador/generate_one_use_link/${userId}`, body)
  }, [])

  return { generateOneUseLink }
}
